import Translation from '@/models/Translation';

export default class TranslationRepository {
    public static getTranslation() {
        return Translation.query().first();
    }
}
